export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getAltAxis.js
// module id = ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
// module chunks = 1